'use strict';

class ParticipantCredited {
  constructor($routeParams, $location, eventService) {
    this.$location = $location;
    this.eventService = eventService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.invoices = {};

    this.load();
  }

  load() {
    this.eventService.invoiceCheck(this.number)
      .then((resp) => {
        this.invoices = resp.data;
      })
      .catch(() => this.$location.path('/vert'));
  }
}

ParticipantCredited.$inject = ['$routeParams', '$location', 'eventService'];

const creditedParticipant = {
  controller: ParticipantCredited,
  template: `
    <h2>Delvis kreditet fakturaer</h2>

    <table>
      <thead>
        <tr>
          <th>Fakturanummer</th>
          <th>Navn</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="invoice in $ctrl.invoices">
          <td>
            <a href="#/kreditnota/{{ invoice.number }}">{{ invoice.number }}</a>
          </td>
          <td>{{ invoice.name }}</td>
          <td class="center-align">
            <a role="button" class="button small secondary" href="#/kreditnota/{{ invoice.number }}"><i class="fa fa-eye"></i> Vis faktura</a>
          </td>
        </tr>
      </tbody>
    </table>

    <a role="button" class="button secondary" href="#/vert">Tilbake</a>
  `
};

angular
  .module('SendRegning')
  .component('participantCredited', creditedParticipant)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/delvis-kreditert', {
        title: 'Delvis kreditert',
        template: '<participant-credited />',
        secure: true
      });
  });
